import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import classNames from 'classnames'
import React from 'react'

const styles = () =>
  createStyles({
    root: {
      borderBottomLeftRadius: 'inherit',
      borderBottomRightRadius: 'inherit',
      display: 'flex',
      width: '100%',
      flex: 1,
    },
  })

interface ICardFooterProps extends WithStyles<typeof styles> {
  children?: React.ReactNode
  className?: string
}

const CardFooter = (props: ICardFooterProps) => {
  const { classes, className, children } = props

  return <div className={classNames(classes.root, className)}>{children}</div>
}

export default withStyles(styles)(CardFooter)
